"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActivatePromocode = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var useActivatePromocode = function (_a) {
    var _b = _a === void 0 ? {} : _a, successAction = _b.successAction, errorAction = _b.errorAction;
    var _c = (0, useMutation_1.useMutation)({
        successAction: successAction,
        errorAction: errorAction,
        keysUpdate: [
            keys_1.MY_BONUSES,
            keys_1.MY_BONUSES_HISTORY,
            keys_1.MY_FREESPINS,
            keys_1.MY_FREESPINS_HISTORY,
        ],
        path: keys_1.ACTIVATE_PROMOCODE,
    }), mutate = _c.mutate, isSubmitting = _c.isSubmitting, error = _c.error, data = _c.data;
    return (0, react_1.useMemo)(function () { return ({
        activatePromocode: mutate,
        isSubmitting: isSubmitting,
        error: error,
        data: data,
    }); }, [mutate, isSubmitting, error, data]);
};
exports.useActivatePromocode = useActivatePromocode;
